// extracted by mini-css-extract-plugin
export default {"container":"AnnouncementBar-module--container--F5Cjd","arrow":"AnnouncementBar-module--arrow--sC7Bz","category":"AnnouncementBar-module--category--5pceC"};